import { render } from "./Playbook.vue?vue&type=template&id=f0aac1ee&ts=true"
import script from "./Playbook.vue?vue&type=script&lang=ts"
export * from "./Playbook.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__